import { createReducer, deleteIn, isMatchId, updateIn } from '../helpers';
import { api } from '../actions';

const setIsFetching = (bool) => (state) => {
    state.isFetching = bool;
};
const changeStatuses = (state, added, removed) => {
    if (added) {
        state.counts[added] = (state.counts[added] || 0) + 1;
    }

    if (removed) {
        state.counts[removed] = Math.max(0, (state.counts[removed] || 0) - 1);
    }

    state.recent = state.counts;
};

const createFeedback = (state, action) => {
    state.isFetching = false;

    if (state.items.find(isMatchId(action.feedbackId))) {
        return;
    }

    state.items.unshift(action.result);
    state.counts.all++;

    changeStatuses(state, action.result.status);
};
const updateFeedback = (state, action) => {
    const old = state.items.find(isMatchId(action.feedbackId));
    updateIn(state.items, isMatchId(action.feedbackId), action.result);

    if (old?.status !== action.result.status) {
        changeStatuses(state, action.result.status, old?.status);
    }

    state.isFetching = false;
};

const identityValues = { all: [], new: [], processing: [], accepted: [], rejected: [] };
const initialState = {
    items: [],
    next: null,
    filter: { website: null, status: 'new' },
    recent: {},
    counts: { all: 0, new: 0, processing: 0, accepted: 0, rejected: 0 },
    totals: identityValues,
    tags: [],
    guid: 0,
    isFetching: false,
};

export default createReducer(initialState, {
    [api.feedbacks.create.request]: setIsFetching(true),
    [api.feedbacks.retrieve.request]: setIsFetching(true),
    [api.feedbacks.list.request]: setIsFetching(true),
    [api.feedbacks.update.request]: setIsFetching(true),
    [api.feedbacks.delete.request]: setIsFetching(true),
    [api.feedbacks.create.failure]: setIsFetching(false),
    [api.feedbacks.update.failure]: setIsFetching(false),
    [api.feedbacks.delete.failure]: setIsFetching(false),
    [api.feedbacks.list.failure]: setIsFetching(false),

    [api.feedbacks.recent.success]: (state, action) => {
        state.recent = action.result.counts;
        state.totals = { ...identityValues, ...action.result.totals };
    },

    [api.feedbacks.create.success]: createFeedback,
    [api.feedbacks.retrieve.success]: (state, action) => {
        if (!updateIn(state.items, isMatchId(action.feedbackId), action.result)) {
            state.items.unshift(action.result);
        }

        state.isFetching = false;
    },
    [api.feedbacks.update.success]: updateFeedback,
    [api.feedbacks.delete.success]: (state, action) => {
        state.isFetching = false;
        state.counts.all = Math.max(0, state.counts.all - 1);
        const old = deleteIn(state.items, isMatchId(action.feedbackId));

        changeStatuses(state, null, old?.status);
    },
    [api.feedbacks.list.success]: (state, { guid, result, query }) => {
        if (guid && guid < state.guid) {
            return state;
        }

        state.items = query?.next ? state.items.concat(result.results) : result.results;
        state.counts = result.counts;
        state.recent = result.counts;
        state.totals = { ...identityValues, ...result.totals };
        state.tags = result.tags;
        state.next = result.next;
        state.isFetching = false;
    },

    [api.orders.update.success]: (state, action) => {
        const feedback = state.items.find(({ purchase }) => purchase?._id === action.orderId);

        if (feedback) {
            updateFeedback(state, {
                feedbackId: feedback._id,
                result: {
                    ...feedback,
                    purchase: action.result,
                },
            });
        }
    },
    [api.listenCreateFeedback]: createFeedback,
    [api.listenUpdateFeedback]: updateFeedback,

    SET_FEEDBACK_ITEMS_FILTER: (state, action) => {
        state.filter = action.payload || {};
        state.next = null;
        state.guid = state.guid + 1;
    },
});
